var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-3 py-3"},[_c('router-view',{attrs:{"eventBus":_vm.eventBus,"account":_vm.account}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }